import type { CSSProperties } from 'react';
import { Typography } from 'design-system';

import { ForbiddenIllustration } from 'src/assets/illustrations';

import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

type RoleBasedGuardProp = {
  hasContent?: boolean;
  roles?: string[];
  children: React.ReactNode;
  style?: CSSProperties;
};

export default function RoleBasedGuard({ hasContent, roles, children, style }: RoleBasedGuardProp) {
  const { user } = useAuthContext();
  const currentRole = user?.role;

  if (typeof roles !== 'undefined' && !roles.includes(currentRole)) {
    return hasContent ? (
      <div className="container" style={{ textAlign: 'center', ...style }}>
        <Typography.Title level={3} style={{ marginBottom: 16 }}>
            Permission Denied
          </Typography.Title>

          <Typography.Text type="secondary">
            You do not have permission to access this page
          </Typography.Text>

          <ForbiddenIllustration
            style={{
              height: 260,
              margin: '40px 0',
            }}
          />
      </div>
    ) : null;
  }

  return <> {children} </>;
}
